import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
    changeEntityStackTab,
    toggleEntityStack,
    swChangeEntityStackTab,
    entityStackRemoveNotification,
} from './actions'

export const mapDispatchToProps = (dispatch) => ({
    changeEntityStackTab: bindActionCreators(changeEntityStackTab, dispatch),
    toggleEntityStack: bindActionCreators(toggleEntityStack, dispatch),
    swChangeEntityStackTab: bindActionCreators(swChangeEntityStackTab, dispatch),
    entityStackRemoveNotification: bindActionCreators(entityStackRemoveNotification, dispatch),
})

export const mapStateToProps = (state) => ({
    activeTab: state.getIn(['ui', 'entityStack', 'tabs', 'activeTab']),
    notifications: state.getIn(['ui', 'entityStack', 'tabs', 'notifications']),
    visibleEntityStack: state.getIn(['ui', 'entityStack', 'tabs', 'visibleEntityStack']),
    ribbonOpen: state.getIn(['ui', 'ribbon', 'open']),
    activeGroupId: state.getIn(['ui', 'groupStack', 'activeGroup']),
})

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            activeGroupId: PropTypes.string,
            activeTab: PropTypes.string,
            changeEntityStackTab: PropTypes.func.isRequired,
            ribbonOpen: PropTypes.bool.isRequired,
            swChangeEntityStackTab: PropTypes.func.isRequired,
            toggleEntityStack: PropTypes.func.isRequired,
            visibleEntityStack: PropTypes.bool.isRequired,
        }

        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
